export const authQueryKeys = {
  me: () => ['auth', 'me'] as const,
}
